import {
    DATIQ_DEFAULT_BOOLEAN,
    DATIQ_DEFAULT_STRING,
} from '@dat/datiq-core/models';
import {
    DatiqOneUserInfoContactMethods,
    DatiqOneUserInfoUser,
    IDatiqFeatureFlag,
    IDatiqFeatureFlagDisabledVariation
} from './datiq-feature-flag.interface';
import {
    camelCase,
    snakeCase
} from 'lodash';

export const DATIQ_FEATURE_FLAG_LOG = `[Datiq Feature Flag]`;
export const createFeatureFlagLogMessage: (message: string) => string = (
    message: string,
): string => `${DATIQ_FEATURE_FLAG_LOG} - ${message}`;
export const emptyDatiqFeatureFlag: IDatiqFeatureFlag = {
    id: DATIQ_DEFAULT_STRING,
    key: DATIQ_DEFAULT_STRING,
    enabled: DATIQ_DEFAULT_BOOLEAN,
    ruleKey: DATIQ_DEFAULT_STRING,
};
export const getDisableVariationKey = (key: string): string =>
    DISABLED_VARIATION;

const DATIQ_FEATURE_FLAG_PREFIX = 'iq';
export const DISABLED_VARIATION = 'disabled';
/**
 * @description The types of flags for the dashboard. "ds" meands datasource such as "ratelane". "com" is for components such as "Rate Lane Graph".
 * @type {string}
 *
 */
export type DATIQ_COMPONENT_TYPES = 'ds' | 'com';
export const getDashboardKey = (
    value: string,
    type: DATIQ_COMPONENT_TYPES,
): string => snakeCase(`${DATIQ_FEATURE_FLAG_PREFIX}_${type}_${value}`);

export const getValueFromDashboardKey = (key: string) => {
    return camelCase(key.split('_')[2]);
};

export const emptyDatiqFeatureFlagDisabledVariation: IDatiqFeatureFlagDisabledVariation =
    {
        message: DATIQ_DEFAULT_STRING,
        tooltip: DATIQ_DEFAULT_STRING,
        ctaLabel: DATIQ_DEFAULT_STRING,
        action: {
            name: DATIQ_DEFAULT_STRING,
        },
        showCta: DATIQ_DEFAULT_BOOLEAN,
        showTooltip: DATIQ_DEFAULT_BOOLEAN,
    };

export const emptyDatiqOneuserInfoContactInfo = {
    firstName: DATIQ_DEFAULT_STRING,
    middleName: DATIQ_DEFAULT_STRING,
    lastName: DATIQ_DEFAULT_STRING,
    title: DATIQ_DEFAULT_STRING,
    prefix: DATIQ_DEFAULT_STRING,
    suffix: DATIQ_DEFAULT_STRING,
    initials: DATIQ_DEFAULT_STRING,
    primaryPhoneNumber: DATIQ_DEFAULT_STRING,
    primaryPhoneExtension: DATIQ_DEFAULT_STRING,
    alternatePhoneNumber: DATIQ_DEFAULT_STRING,
    alternatePhoneExtension: DATIQ_DEFAULT_STRING,
    faxPhoneNumber: DATIQ_DEFAULT_STRING,
    faxPhoneExtension: DATIQ_DEFAULT_STRING,
    emailAddress:  DATIQ_DEFAULT_STRING,
    postersStateProvince: DATIQ_DEFAULT_STRING,
}

export const emptyDatiqOneuser: DatiqOneUserInfoUser = {
    userId: DATIQ_DEFAULT_STRING,
    contactMethods: [{}] as DatiqOneUserInfoContactMethods[],
    contactInfo: emptyDatiqOneuserInfoContactInfo,
}
